var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sf-heading',{staticClass:"sf-heading--left sf-heading--no-underline section-heading",class:{ 'section-heading--decorated': !_vm.noDecor },attrs:{"level":_vm.level,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }